"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArraySanitizer = void 0;
const ArraySanitizer = (value) => {
    if (value.endsWith(',')) {
        throw new SyntaxError("Multiple <list> values should be wrapped inside quotes: --option-name 'value1','value2'");
    }
    return value.split(',').map((string) => string.trim());
};
exports.ArraySanitizer = ArraySanitizer;
